export const Logo = ({ light = false }) => (
  <span className="relative block h-11 w-[143px] sm:h-12 sm:w-[156px]">
    <img
      src="/brand/logo-h-white.png"
      alt="Melo Agro Engenharia"
      className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-500 ${light ? "opacity-100" : "opacity-0"}`}
    />
    <img
      src="/brand/logo-h-dark.png"
      alt=""
      aria-hidden="true"
      className={`absolute inset-0 h-full w-full object-contain transition-opacity duration-500 ${light ? "opacity-0" : "opacity-100"}`}
    />
  </span>
);
